export default __webpack_public_path__ + "static/BannerImageAndTextWithAction-268e741e806ced7875956b5134b169cd.jpg";